import { useDispatch, useSelector } from 'react-redux';
import {loadCustomEvents, loadSpeedAlerts, loadTableAlerts, saveTableAlerts, updateCustomEvents, saveUpdateSpeedAlerts}  from '../actions/customEvents';
import { RootState } from '../reducers';

export const useCustomEventsState = () => {
  const  customEvents  = useSelector((state: RootState) => state.customEvents.customEvents);
  const customAlerts = useSelector((state: RootState) => state.customAlerts);
  const hitedAlerts = useSelector((state: RootState) => state.customAlerts.hitedAlerts);
  const speedAlerts = useSelector((state: RootState) => state.customSpeedAlerts);
  return {customEvents, customAlerts, hitedAlerts, speedAlerts};
};

export const useCustomEventsDispatch = () => {
  const dispatch = useDispatch();
  return {
        loadCustomEvents: (teamId: string, isMobile?:boolean) => dispatch(loadCustomEvents(teamId, isMobile)),
        updateCustomEvents: (eventOne: string, eventTwo: string, eventThree: string, teamId: string, isMobile?:boolean) => 
          dispatch(updateCustomEvents(eventOne, eventTwo, eventThree, teamId, isMobile)),
        loadCustomAlerts: (user:string, teamId:string) => dispatch(loadTableAlerts(user, teamId)),
        saveCustomAlerts: (user:string, teamId:string, customAlert: any) => dispatch(saveTableAlerts(user, teamId, customAlert)),
        loadSpeedAlerts: (user:string , teamId:string) => dispatch(loadSpeedAlerts(user, teamId)),
        saveUpdateSpeedAlerts:(user:string , teamId:string, speedAlerts: any) => dispatch(saveUpdateSpeedAlerts(user, teamId, speedAlerts)),

};
};